import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row g-5 g-xl-10" }
const _hoisted_2 = { class: "col-xl-8" }
const _hoisted_3 = { class: "col-xl-4 mb-10" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = {
  key: 0,
  class: "p-3"
}
const _hoisted_6 = {
  key: 1,
  class: "p-3"
}
const _hoisted_7 = {
  key: 2,
  class: "p-3"
}
const _hoisted_8 = {
  key: 3,
  class: "p-3"
}
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "card card-body d-flex align-items-start mt-5 pt-5" }
const _hoisted_12 = { class: "mb-5 mb-xxl-8" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "align-items-center border-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-dark ps-5" }, "Response Timeline")
  ])
], -1)
const _hoisted_14 = { class: "card-body pt-5" }
const _hoisted_15 = { class: "timeline-label" }
const _hoisted_16 = {
  key: 0,
  class: "timeline-item"
}
const _hoisted_17 = { class: "timeline-label fw-bolder text-gray-800 fs-7" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-badge" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-genderless text-success fs-1" })
], -1)
const _hoisted_19 = { class: "fw-bolder text-gray-800 ps-3" }
const _hoisted_20 = {
  key: 1,
  class: "timeline-item"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-400 fs-7" }, " 00:00 ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-badge" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-genderless text-gray-400 fs-1" })
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-gray-400 ps-3" }, " Transaction Not Found ", -1)
const _hoisted_24 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 2,
  class: "timeline-item"
}
const _hoisted_26 = { class: "timeline-label fw-bolder text-gray-800 fs-7" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-badge" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-genderless text-success fs-1" })
], -1)
const _hoisted_28 = { class: "timeline-content d-flex" }
const _hoisted_29 = { class: "fw-bolder text-gray-800 ps-3" }
const _hoisted_30 = {
  key: 3,
  class: "timeline-item"
}
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-label fw-bolder text-gray-400 fs-7\"> 00:00 </div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-gray-400 fs-1\"></i></div><div class=\"timeline-content d-flex\"><span class=\"fw-bolder text-gray-400 ps-3\">Details Not Populated</span></div>", 3)
const _hoisted_34 = [
  _hoisted_31
]
const _hoisted_35 = {
  key: 4,
  class: "timeline-item"
}
const _hoisted_36 = { class: "timeline-label fw-bolder text-gray-800 fs-7" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-badge" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-genderless text-success fs-1" })
], -1)
const _hoisted_38 = { class: "timeline-content d-flex" }
const _hoisted_39 = { class: "fw-bolder text-gray-800 ps-3" }
const _hoisted_40 = {
  key: 5,
  class: "timeline-item"
}
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-label fw-bolder text-gray-400 fs-7\"> 00:00 </div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-gray-400 fs-1\"></i></div><div class=\"timeline-content d-flex\"><span class=\"fw-bolder text-gray-400 ps-3\">Response Not Sent</span></div>", 3)
const _hoisted_44 = [
  _hoisted_41
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Details = _resolveComponent("Details")!
  const _component_ChargebacksActionToolbar = _resolveComponent("ChargebacksActionToolbar")!
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_Summary = _resolveComponent("Summary")!
  const _component_AddChargebackResponseDrawer = _resolveComponent("AddChargebackResponseDrawer")!
  const _component_ViewIncomingDetailsDrawer = _resolveComponent("ViewIncomingDetailsDrawer")!
  const _component_SearchApiModal = _resolveComponent("SearchApiModal")!
  const _component_PdfViewModal = _resolveComponent("PdfViewModal")!
  const _component_QRViewModal = _resolveComponent("QRViewModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Details, {
          reason_explained: _ctx.reason_explained,
          reason: _ctx.reason,
          merchant: _ctx.merchant,
          incoming: _ctx.incoming
        }, null, 8, ["reason_explained", "reason", "merchant", "incoming"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_ChargebacksActionToolbar, {
            incomingData: _ctx.incoming,
            processor: _ctx.processor,
            onReloadIncoming: _ctx.resetIncoming,
            onOpenDrawer: _ctx.onOpenResponseDrawer,
            onFormEntry: _ctx.onFormEntry,
            onViewDispute: _ctx.onViewDispute,
            apiSyncItems: _ctx.apiSyncItems,
            connections: _ctx.connections
          }, null, 8, ["incomingData", "processor", "onReloadIncoming", "onOpenDrawer", "onFormEntry", "onViewDispute", "apiSyncItems", "connections"])
        ]),
        (_ctx.incoming.transaction_found == '0' && _ctx.incoming.dispute_url == '' && _ctx.incoming.is_responded == '0' )
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_el_steps, { active: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_step, { title: "populate" }),
                  _createVNode(_component_el_step, { title: "create" }),
                  _createVNode(_component_el_step, { title: "send" })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.incoming.transaction_found == '1' && _ctx.incoming.dispute_url == '' && _ctx.incoming.is_responded == '0')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_el_steps, {
                active: 1,
                "finish-status": "success"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_step, { title: "populated" }),
                  _createVNode(_component_el_step, { title: "create" }),
                  _createVNode(_component_el_step, { title: "send" })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.incoming.transaction_found == '1' && _ctx.incoming.dispute_url != '' && _ctx.incoming.is_responded == '0')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_el_steps, {
                active: 2,
                "finish-status": "success"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_step, { title: "populated" }),
                  _createVNode(_component_el_step, { title: "created" }),
                  _createVNode(_component_el_step, { title: "send" })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.incoming.transaction_found == '1' && _ctx.incoming.dispute_url != '' && _ctx.incoming.is_responded == '1')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_el_steps, {
                active: 3,
                "finish-status": "success"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_step, { title: "populated" }),
                  _createVNode(_component_el_step, { title: "created" }),
                  _createVNode(_component_el_step, { title: "sent" })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_Summary, {
              reason: _ctx.reason,
              processor: _ctx.processor,
              merchant: _ctx.merchant,
              incoming: _ctx.incoming
            }, null, 8, ["reason", "processor", "merchant", "incoming"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                (_ctx.incoming.found_date != '0000-00-00 00:00:00')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.getFoundTime), 1),
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, " Transaction Found (" + _toDisplayString(_ctx.getFoundDate) + ") ", 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_24)),
                (_ctx.incoming.populated_date != '0000-00-00 00:00:00')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.getPopulatedTime), 1),
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("span", _hoisted_29, "Details Populated (" + _toDisplayString(_ctx.getPopulatedDate) + ")", 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_34)),
                (_ctx.incoming.sent_date != '0000-00-00 00:00:00')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.getSentTime), 1),
                      _hoisted_37,
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("span", _hoisted_39, "Response Sent (" + _toDisplayString(_ctx.getSentDate) + ")", 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_44))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_AddChargebackResponseDrawer, {
      templatesData: _ctx.templates,
      templateImages: _ctx.templateImages,
      incoming: _ctx.incoming,
      onSubmit: _ctx.submitTemplate,
      reason_explained: _ctx.reason_explained,
      reason: _ctx.reason
    }, null, 8, ["templatesData", "templateImages", "incoming", "onSubmit", "reason_explained", "reason"]),
    _createVNode(_component_ViewIncomingDetailsDrawer, { incomingData: _ctx.incoming }, null, 8, ["incomingData"]),
    _createVNode(_component_SearchApiModal, { onReloadIncoming: _ctx.resetIncoming }, null, 8, ["onReloadIncoming"]),
    _createVNode(_component_PdfViewModal, {
      url: _ctx.incoming.dispute_url
    }, null, 8, ["url"]),
    _createVNode(_component_QRViewModal, {
      url: _ctx.incoming.dispute_url
    }, null, 8, ["url"])
  ], 64))
}